import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Check KM',
      title: 'Check KM',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Success',
    }
  }
}